import { Phone, Mail, MapPin } from "lucide-react";
import { useLang } from "@/context/LangContext";

const LOGO_URL = "/logo-blanc.png";

export default function Footer() {
  const { t } = useLang();

  const navLinks = [
    { label: t.nav.accueil, href: "#accueil" },
    { label: t.nav.experiences, href: "#experiences" },
    { label: t.nav.forfaits, href: "#forfaits" },
    { label: t.nav.location, href: "#location" },
    { label: t.nav.voiceover, href: "#voiceover" },
    { label: t.nav.soumission, href: "#soumission" },
  ];

  return (
    <footer className="relative bg-[#050505] border-t border-red-900/15" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="mb-4 w-fit" style={{ filter: "drop-shadow(0 0 1px rgba(255,255,255,0.4))" }}>
              <img src={LOGO_URL} alt="Les Productions DJMIX.CA" className="h-10 sm:h-12 w-auto object-contain" />
            </div>
            <p className="font-body text-sm text-[#A3A3A3] leading-relaxed max-w-xs">
              {t.footer.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-white mb-4">{t.footer.nav_title}</h4>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="font-body text-sm text-[#A3A3A3] hover:text-[#E60000] transition-colors">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold uppercase tracking-widest text-white mb-4">{t.footer.contact_title}</h4>
            <ul className="space-y-3">
              <li><a href="tel:+15144330846" className="flex items-center gap-3 font-body text-sm text-[#A3A3A3] hover:text-[#E60000] transition-colors" data-testid="footer-phone"><Phone size={16} className="text-[#E60000]" /> 514 433-0846</a></li>
              <li><a href="mailto:studio@djmix.ca" className="flex items-center gap-3 font-body text-sm text-[#A3A3A3] hover:text-[#E60000] transition-colors" data-testid="footer-email"><Mail size={16} className="text-[#E60000]" /> studio@djmix.ca</a></li>
              <li className="flex items-center gap-3 font-body text-sm text-[#A3A3A3]"><MapPin size={16} className="text-[#E60000]" /> Montréal, Québec</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 text-center">
          <p className="font-body text-xs text-white/30">
            {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
